import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppConfigurationService} from "../../../common/app-config/app-configuration.service";
import {PopupWindowService} from "../../../common/services/popup.window.service";
import {RtlService} from "../../../common/intl/services/rtl.service";
import {takeUntilDestroy} from "take-until-destroy";


@Component({
  selector: 'app-login-general',
  templateUrl: './login-general.component.html',
  styleUrls: ['./login-general.component.scss']
})
export class LoginGeneralComponent implements OnInit, OnDestroy {

  public IsExternalLogin:boolean;
  public dir: string = "ltr";

  constructor(private appConfigService: AppConfigurationService,
              private popupWindowService: PopupWindowService,
              private rtlService: RtlService) {
  }

  ngOnInit() {
    this.IsExternalLogin = this.appConfigService.Config.externalAuthentication;

    this.rtlService.getLoginRtlModeObservable().pipe(takeUntilDestroy(this)).subscribe(m => {
      this.dir = m ? 'rtl' : 'ltr';
    });

    // close popup if it was left open on auto logout
    this.popupWindowService.closeAllPopups();
  }

  ngOnDestroy(): void {
  }
}
